import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=3e323eeb"
import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=3e323eeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports